// MobileToolbar component extracted from OfferPageBuilderSimple.js lines 10825-10897
import React from 'react';
import { Box, Card, CardContent, IconButton } from '@mui/material';
import {
  Menu as MenuIcon,
  Phone as PhoneIcon,
  Tablet as TabletIcon,
  Computer as ComputerIcon,
  Add as AddIcon,
  GetApp as ExportIcon,
} from '@mui/icons-material';
import { useOfferBuilder } from '../OfferBuilderContext';

const MobileToolbar = () => {
  const {
    setMobileDrawerOpen,
    previewDevice,
    setPreviewDevice,
    addPage,
    generateHTML,
    paginationEnabled,
    pages,
    pageSettings,
  } = useOfferBuilder();

  return (
    <Card sx={{
      position: 'fixed',
      bottom: 16,
      left: 16,
      right: 16,
      zIndex: 1000,
      display: { xs: 'block', md: 'none' }
    }}>
      <CardContent sx={{ p: 1, '&:last-child': { pb: 1 } }}>
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', justifyContent: 'space-between' }}>
          <IconButton
            size="small"
            onClick={() => setMobileDrawerOpen(true)}
            color="primary"
          >
            <MenuIcon />
          </IconButton>

          <Box sx={{ display: 'flex', gap: 1 }}>
            <IconButton
              size="small"
              onClick={() => {
                if (previewDevice === 'mobile') setPreviewDevice('tablet');
                else if (previewDevice === 'tablet') setPreviewDevice('desktop');
                else setPreviewDevice('mobile');
              }}
              color={previewDevice === 'mobile' ? 'primary' : previewDevice === 'tablet' ? 'secondary' : 'default'}
              title={
                previewDevice === 'mobile' ? 'Switch to Tablet' :
                  previewDevice === 'tablet' ? 'Switch to Desktop' :
                    'Switch to Phone'
              }
            >
              {previewDevice === 'mobile' ? <PhoneIcon /> :
                previewDevice === 'tablet' ? <TabletIcon /> :
                  <ComputerIcon />}
            </IconButton>

            {/* Add Page Button - Always visible */}
            <IconButton
              size="small"
              onClick={addPage}
              color="primary"
              title="Add page"
            >
              <AddIcon />
            </IconButton>
          </Box>

          <IconButton
            size="small"
            onClick={() => {
              const html = generateHTML();
              const blob = new Blob([html], { type: 'text/html' });
              const url = URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              const filename = paginationEnabled && pages.length > 1
                ? `${pageSettings.title.replace(/\s+/g, '_')}_${pages.length}pages.html`
                : `${pageSettings.title.replace(/\s+/g, '_')}.html`;
              a.download = filename;
              a.click();
              URL.revokeObjectURL(url);
            }}
            color="secondary"
          >
            <ExportIcon />
          </IconButton>
        </Box>
      </CardContent>
    </Card>
  );
};

export default MobileToolbar;
